
// import React, { useState, useRef, useEffect } from 'react';
// import axios from 'axios';
// import {
//   TextField,
//   MenuItem,
//   Button,
//   Typography,
//   Box
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import './PaymentForm.css';

// const subCategoryOptions = {
//   mining: [
//     { label: "Upto 2 hectares", value: "Upto 2 hectares", amount: 10000 },
//     { label: "Above 2 hectares to 5 hectares", value: "Above 2 hectares to 5 hectares", amount: 18000 },
//     { label: "Above 5 hectares to 25 hectares", value: "Above 5 hectares to 25 hectares", amount: 90000 },
//     { label: "Above 25 hectares to 50 hectares", value: "Above 25 hectares to 50 hectares", amount: 180000 }
//   ],
//   nonMining: [
//     { label: "Upto Rs.5 Crores", value: "Upto Rs.5 Crores", amount: 100000 },
//     { label: "Above Rs.5 Crores to Rs.25 Crores", value: "Above Rs.5 Crores to Rs.25 Crores", amount: 180000 },
//     { label: "Above Rs.25 Crores to Rs.100 Crores", value: "Above Rs.25 Crores to Rs.100 Crores", amount: 270000 },
//     { label: "Above Rs.100 Crores", value: "Above Rs.100 Crores", amount: 450000 }
//   ]
// };

// const PaymentForm = () => {
//   const [formData, setFormData] = useState({
//     proponentName: '',
//     projectType: '',
//     subCategory: '',
//     mobileNumber: '',
//     email: '',
//     amount: ''
//   });

//   const [activeTab, setActiveTab] = useState('fees');
//   const [receiptInputs, setReceiptInputs] = useState({
//     registrationNo: '',
//     mobileNumber: ''
//   });

//   const navigate = useNavigate();
//   const formRef = useRef(null);

//   useEffect(() => {
//     const loadRazorpay = () => {
//       const script = document.createElement('script');
//       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//       script.onload = () => true;
//       document.body.appendChild(script);
//     };
//     loadRazorpay();
//   }, []);

//   const handleFormChange = (e) => {
//     const { name, value } = e.target;
//     const newForm = { ...formData, [name]: value };

//     if (name === "projectType" || name === "subCategory") {
//       const match = subCategoryOptions[newForm.projectType]?.find(opt => opt.value === newForm.subCategory);
//       newForm.amount = match?.amount || '';
//     }

//     setFormData(newForm);
//   };

//   const isFormValid = () => {
//     const { proponentName, projectType, subCategory, mobileNumber, email, amount } = formData;
//     return proponentName && projectType && subCategory && mobileNumber && email && amount;
//   };

//   const handleSubmit = (type) => {
//     if (!isFormValid()) {
//       alert('Please fill all required fields.');
//       return;
//     }
//     console.log(`${type} submitted:`, formData);
//   };

//  const handlePayOnline = async () => {
//   if (!isFormValid()) return alert('Please fill all fields');

//   try {
//     // 1. Create Razorpay order
//     const orderResponse = await axios.post(`${process.env.REACT_APP_API_URL}/api/create-razorpay-order`, {
//       amount: formData.amount,
//       customer_name: formData.proponentName,
//       customer_phone: formData.mobileNumber,
//       customer_email: formData.email,
//       project_type: formData.projectType,
//       sub_category: formData.subCategory
//     });

//     // 2. Initialize Razorpay
//     const options = {
//       key: orderResponse.data.key_id,
//       order_id: orderResponse.data.order_id,
//       amount: orderResponse.data.amount,
//       currency: "INR",
//       name: "Hithlaksh Software Solutions",
//       description: "Payment for services",
//       handler: async (response) => {
//         try {
//           // 3. Verify and save payment
//           const saveResponse = await axios.post(
//             `${process.env.REACT_APP_API_URL}/api/verify-payment`, 
//             {
//               razorpay_payment_id: response.razorpay_payment_id,
//               razorpay_order_id: response.razorpay_order_id,
//               razorpay_signature: response.razorpay_signature,
//               formData: {
//                 proponentName: formData.proponentName,
//                 projectType: formData.projectType,
//                 subCategory: formData.subCategory,
//                 mobileNumber: formData.mobileNumber,
//                 email: formData.email,
//                 amount: formData.amount
//               }
//             }
//           );

//           // 4. Redirect with success data
//           navigate('/thank-you', {
//             state: { 
//               status: 'success',
//               paymentId: response.razorpay_payment_id,
//               receiptUrl: saveResponse.data.receiptUrl 
//             }
//           });
//         } catch (error) {
//           navigate('/thank-you', { state: { status: 'failed' } });
//         }
//       },
//       prefill: {
//         name: formData.proponentName,
//         email: formData.email,
//         contact: formData.mobileNumber
//       }
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   } catch (error) {
//     alert(`Payment failed: ${error.response?.data?.error || error.message}`);
//   }
// };

//   //   if (!isFormValid()) {
//   //     alert('Please fill all required fields.');
//   //     return;
//   //   }

//   //   try {
//   //     const orderResponse = await axios.post(`${process.env.REACT_APP_BACKEND_API_HOST}/api/create-razorpay-order`, {
//   //       amount: formData.amount,
//   //       customer_name: formData.proponentName,
//   //       customer_phone: formData.mobileNumber,
//   //       customer_email: formData.email,
//   //       project_type: formData.projectType,
//   //       sub_category: formData.subCategory
//   //     });

//   //     if (!window.Razorpay) throw new Error('Razorpay failed to load.');

//   //     const options = {
//   //       key: orderResponse.data.key_id,
//   //       order_id: orderResponse.data.order_id,
//   //       amount: orderResponse.data.amount,
//   //       currency: "INR",
//   //       name: "Your Company",
//   //       description: "Payment",
//   //       handler: async function (response) {
//   //         try {
//   //           const verifyResponse = await axios.post(
//   //             `${process.env.REACT_APP_BACKEND_API_HOST}/api/verify-payment`,
//   //             {
//   //               razorpay_payment_id: response.razorpay_payment_id,
//   //               razorpay_order_id: response.razorpay_order_id,
//   //               razorpay_signature: response.razorpay_signature
//   //             }
//   //           );

//   //           if (verifyResponse.data.redirectUrl) {
//   //             window.location.href = verifyResponse.data.redirectUrl;
//   //           } else {
//   //             navigate('/thank-you', {
//   //               state: {
//   //                 paymentId: response.razorpay_payment_id,
//   //                 status: 'success'
//   //               }
//   //             });
//   //           }
//   //         } catch (error) {
//   //           navigate('/thank-you', { state: { status: 'failed' } });
//   //         }
//   //       },
//   //       prefill: {
//   //         name: formData.proponentName,
//   //         email: formData.email,
//   //         contact: formData.mobileNumber
//   //       },
//   //       theme: {
//   //         color: "#3399cc"
//   //       }
//   //     };

//   //     const rzp = new window.Razorpay(options);
//   //     rzp.open();
//   //   } catch (error) {
//   //     alert(`Payment failed: ${error.response?.data?.error || error.message}`);
//   //     navigate('/thank-you', { state: { status: 'failed' } });
//   //   }
//   // };

//   const handleReceiptChange = (e) => {
//     setReceiptInputs({ ...receiptInputs, [e.target.name]: e.target.value });
//   };

//   const handleViewReceipts = async () => {
//   const searchKey = receiptInputs.registrationNo || receiptInputs.mobileNumber;
//   if (!searchKey) return alert('Enter search criteria');

//   try {
//     const response = await axios.get(
//       `${process.env.REACT_APP_API_URL}/api/payments/${searchKey}`
//     );

//     if (response.data.payments.length === 0) {
//       alert('No payments found');
//     } else {
//       // Display results (see next step for UI)
//       console.log(response.data.payments);
//     }
//   } catch (error) {
//     alert('Failed to fetch payments');
//   }
// };

//   // const handleViewReceipts = () => {
//   //   if (!receiptInputs.registrationNo && !receiptInputs.mobileNumber) {
//   //     alert('Please enter Registration No or Mobile Number.');
//   //     return;
//   //   }
//   //   console.log("Fetching receipts for:", receiptInputs);
//   //   // You can make backend call here to fetch receipts
//   // };

//   return (
//     <Box className="payment-container">
//       <div className="tab-buttons">
//         <button
//           className={activeTab === 'fees' ? 'active-tab' : ''}
//           onClick={() => setActiveTab('fees')}
//         >
//           FEES PAYMENT
//         </button>
//         <button
//           className={activeTab === 'receipts' ? 'active-tab' : ''}
//           onClick={() => setActiveTab('receipts')}
//         >
//           PAYMENT RECEIPTS
//         </button>
//       </div>

//       {activeTab === 'fees' ? (
//         <>
//           <Typography variant="h6" mb={2}>Payment Form</Typography>
//           <div className="form-grid">
//             <TextField fullWidth label="Proponent Name *" name="proponentName" value={formData.proponentName} onChange={handleFormChange} />
//             <TextField select fullWidth label="Project Type *" name="projectType" value={formData.projectType} onChange={handleFormChange}>
//               <MenuItem value="" disabled>Select option</MenuItem>
//               <MenuItem value="mining">Mining</MenuItem>
//               <MenuItem value="nonMining">Non Mining</MenuItem>
//             </TextField>
//             <TextField select fullWidth label="Sub Category *" name="subCategory" value={formData.subCategory} onChange={handleFormChange} disabled={!formData.projectType}>
//               <MenuItem value="" disabled>Select option</MenuItem>
//               {(subCategoryOptions[formData.projectType] || []).map((option) => (
//                 <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
//               ))}
//             </TextField>
//             <TextField fullWidth label="Mobile Number *" name="mobileNumber" value={formData.mobileNumber} onChange={handleFormChange} />
//             <TextField fullWidth label="Email *" name="email" value={formData.email} onChange={handleFormChange} />
//             <TextField fullWidth label="Amount *" name="amount" type="number" value={formData.amount} InputProps={{ readOnly: true }} />
//           </div>

//           <Box mt={3} className="action-buttons">
//             <Button variant="outlined" className="form-button cancel-btn" onClick={() => handleSubmit('Cancel')}>Cancel</Button>
//             <Button variant="contained" className="form-button cash-btn" onClick={() => handleSubmit('Cash')}>Cash Collection</Button>
//             <Button variant="contained" className="form-button pay-btn" onClick={handlePayOnline}>Pay Online</Button>
//           </Box>
//         </>
//       ) : (
//         <Box className="receipt-wrapper">
//           <Typography variant="h6" mb={2}>Receipt Lookup</Typography>
//           <p>Enter Registration Number OR Mobile Number to view previous receipts</p>
//           <div className="receipt-form">
//             <TextField
//               label="Registration No"
//               name="registrationNo"
//               value={receiptInputs.registrationNo}
//               onChange={handleReceiptChange}
//               fullWidth
//             />
//             <TextField
//               label="Mobile Number"
//               name="mobileNumber"
//               value={receiptInputs.mobileNumber}
//               onChange={handleReceiptChange}
//               fullWidth
//             />
//            <Button
//   variant="contained"
//   className="view-btn"
//   onClick={handleViewReceipts}
// >
//   VIEW RECEIPTS
// </Button>

//           </div>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default PaymentForm;




// import React, { useState, useRef, useEffect } from 'react';
// import axios from 'axios';
// import {
//   TextField,
//   MenuItem,
//   Button,
//   Typography,
//   Box,
//   Paper, // Added for displaying receipts
//   List, // Added for displaying receipts
//   ListItem, // Added for displaying receipts
//   ListItemText, // Added for displaying receipts
//   Divider // Added for displaying receipts
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import './PaymentForm.css'; // Assuming you have this CSS file

// const subCategoryOptions = {
//   mining: [
//     { label: "Upto 2 hectares", value: "Upto 2 hectares", amount: 10000 },
//     { label: "Above 2 hectares to 5 hectares", value: "Above 2 hectares to 5 hectares", amount: 18000 },
//     { label: "Above 5 hectares to 25 hectares", value: "Above 25 hectares to 50 hectares", amount: 90000 },
//     { label: "Above 25 hectares to 50 hectares", value: "Above 25 hectares to 50 hectares", amount: 180000 }
//   ],
//   nonMining: [
//     { label: "Upto Rs.5 Crores", value: "Upto Rs.5 Crores", amount: 100000 },
//     { label: "Above Rs.5 Crores to Rs.25 Crores", value: "Above Rs.5 Crores to Rs.25 Crores", amount: 180000 },
//     { label: "Above Rs.25 Crores to Rs.100 Crores", value: "Above Rs.25 Crores to Rs.100 Crores", amount: 270000 },
//     { label: "Above Rs.100 Crores", value: "Above Rs.100 Crores", amount: 450000 }
//   ]
// };

// const PaymentForm = () => {
//   const [formData, setFormData] = useState({
//     proponentName: '',
//     projectType: '',
//     subCategory: '',
//     mobileNumber: '',
//     email: '',
//     amount: ''
//   });

//   const [activeTab, setActiveTab] = useState('fees');
//   const [receiptInputs, setReceiptInputs] = useState({
//     registrationNo: '', // This will map to razorpay_order_id on backend search
//     mobileNumber: ''
//   });
//   const [fetchedReceipts, setFetchedReceipts] = useState([]); // State to store fetched receipts

//   const navigate = useNavigate();
//   const formRef = useRef(null);
//   const currentOrderId = useRef(null); // To store order_id for failed payments

//   useEffect(() => {
//     // Load Razorpay script only once
//     const loadRazorpay = () => {
//       const script = document.createElement('script');
//       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//       script.onload = () => {
//         console.log('Razorpay script loaded successfully.');
//       };
//       script.onerror = () => {
//         console.error('Failed to load Razorpay script.');
//       };
//       document.body.appendChild(script);
//     };
//     loadRazorpay();
//   }, []);

//   const handleFormChange = (e) => {
//     const { name, value } = e.target;
//     const newForm = { ...formData, [name]: value };

//     if (name === "projectType" || name === "subCategory") {
//       const match = subCategoryOptions[newForm.projectType]?.find(opt => opt.value === newForm.subCategory);
//       newForm.amount = match?.amount || '';
//     }

//     setFormData(newForm);
//   };

//   const isFormValid = () => {
//     const { proponentName, projectType, subCategory, mobileNumber, email, amount } = formData;
//     // Basic validation: ensure all fields have a value
//     return proponentName && projectType && subCategory && mobileNumber && email && amount;
//   };

//   const handleSubmit = (type) => {
//     if (!isFormValid()) {
//       alert('Please fill all required fields.');
//       return;
//     }
//     console.log(`${type} submitted:`, formData);
//     // For 'Cash Collection' or 'Cancel', you would typically handle this logic here,
//     // e.g., send data to a different endpoint or clear the form.
//   };

//   const handlePayOnline = async () => {
//     if (!isFormValid()) {
//       alert('Please fill all required fields before proceeding with payment.');
//       return;
//     }

//     try {
//       // 1. Create Razorpay order on your backend
//       console.log('Attempting to create Razorpay order with:', formData.amount, formData.proponentName);
//       const apiURL = process.env.REACT_APP_API_URL || 'YOUR_FIREBASE_FUNCTION_URL';
//       console.log('API URL being used:', apiURL);

//       const orderResponse = await axios.post(`${apiURL}/api/create-razorpay-order`, {
//         amount: formData.amount,
//         customer_name: formData.proponentName,
//         customer_phone: formData.mobileNumber,
//         customer_email: formData.email,
//         project_type: formData.projectType, // Pass additional data for notes
//         sub_category: formData.subCategory   // Pass additional data for notes
//       });

//       console.log('Backend Order Response:', orderResponse.data);

//       const { order_id, key_id } = orderResponse.data;
//       currentOrderId.current = order_id; // Store the order ID for potential failure handling

//       // Crucial check: Ensure key_id is received
//       if (!key_id) {
//         console.error('Error: Razorpay key_id is missing from backend response.');
//         alert('Payment initiation failed: Razorpay Key is missing. Please contact support.');
//         navigate('/thank-you', { state: { status: 'failed' } });
//         return;
//       }

//       // Ensure Razorpay script is loaded
//       if (!window.Razorpay) {
//         alert('Razorpay SDK not loaded. Please try again or refresh the page.');
//         return;
//       }

//       // 2. Initialize Razorpay Checkout
//       const options = {
//         key: key_id,
//         order_id: order_id,
//         amount: formData.amount * 100, // Amount in paise
//         currency: "INR",
//         name: "Hithlaksh Software Solutions", // Your company name
//         description: "Payment for services",
//         handler: async (response) => {
//           try {
//             // 3. Verify payment on your backend and save details to Firestore
//             console.log('Razorpay payment successful, verifying with backend...');
//             const verifyResponse = await axios.post(
//               `${apiURL}/api/verify-payment`,
//               {
//                 razorpay_payment_id: response.razorpay_payment_id,
//                 razorpay_order_id: response.razorpay_order_id,
//                 razorpay_signature: response.razorpay_signature,
//                 formData: formData // Pass the full form data to the backend
//               }
//             );

//             console.log('Backend Verification Response:', verifyResponse.data);

//             // 4. Redirect based on backend response
//             if (verifyResponse.data.redirectUrl) {
//               window.location.href = verifyResponse.data.redirectUrl;
//             } else {
//               // Fallback if backend doesn't provide redirectUrl
//               navigate('/thank-you', {
//                 state: {
//                   status: 'success',
//                   paymentId: response.razorpay_payment_id,
//                   receiptUrl: verifyResponse.data.receiptUrl // Pass receipt URL
//                 }
//               });
//             }
//           } catch (error) {
//             console.error('Payment verification failed on frontend:', error.response?.data || error.message);
//             // Navigate to thank-you page with failed status
//             alert(`Payment verification failed: ${error.response?.data?.error || error.message}`);
//             navigate('/thank-you', { state: { status: 'failed' } });
//           }
//         },
//         prefill: {
//           name: formData.proponentName,
//           email: formData.email,
//           contact: formData.mobileNumber
//         },
//         theme: {
//           color: "#3399cc"
//         }
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.on('payment.failed', async function (response) {
//         console.error('Razorpay payment failed:', response.error);

//         // Call backend to update payment status to 'failed' in Firestore
//         if (currentOrderId.current) {
//           try {
//             await axios.post(`${apiURL}/api/update-payment-status`, {
//               order_id: currentOrderId.current,
//               error_details: response.error.description || 'User cancelled payment'
//             });
//             console.log('Payment status updated to failed in Firestore.');
//           } catch (firestoreError) {
//             console.error('Failed to update payment status in Firestore on Razorpay failure:', firestoreError);
//           }
//         }

//         alert(`Payment Failed: ${response.error.description || 'Unknown error'}. Error code: ${response.error.code}`);
//         navigate('/thank-you', { state: { status: 'failed' } });
//       });
//       rzp.open();

//     } catch (error) {
//       console.error('Error creating Razorpay order:', error.response?.data || error.message);
//       // If order creation itself failed (e.g., due to backend auth error), then currentOrderId.current might not be set.
//       // No Firestore update here as no Razorpay order_id was generated.
//       alert(`Payment initiation failed: ${error.response?.data?.error || error.message}`);
//       navigate('/thank-you', { state: { status: 'failed' } });
//     }
//   };

//   const handleReceiptChange = (e) => {
//     setReceiptInputs({ ...receiptInputs, [e.target.name]: e.target.value });
//   };

//   const handleViewReceipts = async () => {
//     const searchKey = receiptInputs.registrationNo || receiptInputs.mobileNumber;
//     if (!searchKey) {
//       alert('Please enter either Registration Number or Mobile Number to search for receipts.');
//       return;
//     }

//     try {
//       // Make a GET request to the new backend endpoint
//       const apiURL = process.env.REACT_APP_API_URL || 'YOUR_FIREBASE_FUNCTION_URL';
//       const response = await axios.get(
//         `${apiURL}/api/payments/${searchKey}`
//       );

//       if (response.data.payments.length === 0) {
//         alert('No payments found for the given criteria.');
//         setFetchedReceipts([]); // Clear previous results
//       } else {
//         setFetchedReceipts(response.data.payments); // Store fetched payments in state
//         console.log('Fetched payments:', response.data.payments);
//       }
//     } catch (error) {
//       console.error('Failed to fetch payments:', error.response?.data || error.message);
//       alert('Failed to fetch payments. Please check the search criteria and try again.');
//       setFetchedReceipts([]); // Clear previous results on error
//     }
//   };

//   return (
//     <Box className="payment-container">
//       <div className="tab-buttons">
//         <button
//           className={activeTab === 'fees' ? 'active-tab' : ''}
//           onClick={() => setActiveTab('fees')}
//         >
//           FEES PAYMENT
//         </button>
//         <button
//           className={activeTab === 'receipts' ? 'active-tab' : ''}
//           onClick={() => setActiveTab('receipts')}
//         >
//           PAYMENT RECEIPTS
//         </button>
//       </div>

//       {activeTab === 'fees' ? (
//         <>
//           <Typography variant="h6" mb={2}>Payment Form</Typography>
//           <div className="form-grid">
//             <TextField fullWidth label="Proponent Name *" name="proponentName" value={formData.proponentName} onChange={handleFormChange} />
//             <TextField select fullWidth label="Project Type *" name="projectType" value={formData.projectType} onChange={handleFormChange}>
//               <MenuItem value="" disabled>Select option</MenuItem>
//               <MenuItem value="mining">Mining</MenuItem>
//               <MenuItem value="nonMining">Non Mining</MenuItem>
//             </TextField>
//             <TextField select fullWidth label="Sub Category *" name="subCategory" value={formData.subCategory} onChange={handleFormChange} disabled={!formData.projectType}>
//               <MenuItem value="" disabled>Select option</MenuItem>
//               {(subCategoryOptions[formData.projectType] || []).map((option) => (
//                 <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
//               ))}
//             </TextField>
//             <TextField fullWidth label="Mobile Number *" name="mobileNumber" value={formData.mobileNumber} onChange={handleFormChange} />
//             <TextField fullWidth label="Email *" name="email" value={formData.email} onChange={handleFormChange} />
//             <TextField fullWidth label="Amount *" name="amount" type="number" value={formData.amount} InputProps={{ readOnly: true }} />
//           </div>

//           <Box mt={3} className="action-buttons">
//             <Button variant="outlined" className="form-button cancel-btn" onClick={() => handleSubmit('Cancel')}>Cancel</Button>
//             <Button variant="contained" className="form-button cash-btn" onClick={() => handleSubmit('Cash')}>Cash Collection</Button>
//             <Button variant="contained" className="form-button pay-btn" onClick={handlePayOnline}>Pay Online</Button>
//           </Box>
//         </>
//       ) : (
//         <Box className="receipt-wrapper">
//           <Typography variant="h6" mb={2}>Receipt Lookup</Typography>
//           <p>Enter Registration Number OR Mobile Number to view previous receipts</p>
//           <div className="receipt-form">
//             <TextField
//               label="Registration No (e.g., Razorpay Order ID)"
//               name="registrationNo"
//               value={receiptInputs.registrationNo}
//               onChange={handleReceiptChange}
//               fullWidth
//               helperText="This field is currently mapped to Razorpay Order ID for lookup."
//             />
//             <TextField
//               label="Mobile Number"
//               name="mobileNumber"
//               value={receiptInputs.mobileNumber}
//               onChange={handleReceiptChange}
//               fullWidth
//             />
//             <Button
//               variant="contained"
//               className="view-btn"
//               onClick={handleViewReceipts}
//             >
//               VIEW RECEIPTS
//             </Button>
//           </div>

//           {fetchedReceipts.length > 0 && (
//             <Box mt={4}>
//               <Typography variant="h6">Found Receipts:</Typography>
//               <Paper elevation={3} style={{ maxHeight: 300, overflow: 'auto', marginTop: '10px' }}>
//                 <List>
//                   {fetchedReceipts.map((receipt, index) => (
//                     <React.Fragment key={receipt.id}>
//                       <ListItem alignItems="flex-start">
//                         <ListItemText
//                           primary={`Payment ID: ${receipt.razorpay_payment_id || 'N/A'}`}
//                           secondary={
//                             <>
//                               <Typography component="span" variant="body2" color="text.primary">
//                                 Customer: {receipt.customer_name || 'N/A'} - Mobile: {receipt.customer_phone || 'N/A'}
//                               </Typography>
//                               <br />
//                               Amount: ₹{receipt.amount} ({receipt.project_type} - {receipt.sub_category})
//                               <br />
//                               Order ID: {receipt.razorpay_order_id}
//                               <br />
//                               Status: **{receipt.status.toUpperCase()}** {receipt.razorpay_error && `(${receipt.razorpay_error})`}
//                               <br />
//                               {/* Convert timestamp string to Date object before formatting */}
//                               {receipt.timestamp && `Initiated: ${new Date(receipt.timestamp).toLocaleString()}`}
//                               {/* Convert updatedAt string to Date object before formatting */}
//                               {receipt.updatedAt && ` | Last Updated: ${new Date(receipt.updatedAt).toLocaleString()}`}
//                               <br />
//                               {receipt.pdf_receipt_url && receipt.status === 'completed' && (
//                                 <a href={receipt.pdf_receipt_url} target="_blank" rel="noopener noreferrer">View Receipt PDF</a>
//                               )}
//                             </>
//                           }
//                         />
//                       </ListItem>
//                       {index < fetchedReceipts.length - 1 && <Divider component="li" />}
//                     </React.Fragment>
//                   ))}
//                 </List>
//               </Paper>
//             </Box>
//           )}
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default PaymentForm;



import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import {
  TextField,
  MenuItem,
  Button,
  Typography,
  Box,
  Paper, // Added for displaying receipts
  List, // Added for displaying receipts
  ListItem, // Added for displaying receipts
  ListItemText, // Added for displaying receipts
  Divider, // Added for displaying receipts
  Link // <--- ADDED: For the Forgot Password link
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './PaymentForm.css'; // Assuming you have this CSS file

const subCategoryOptions = {
  mining: [
    { label: "Upto 2 hectares", value: "Upto 2 hectares", amount: 10000 },
    { label: "Above 2 hectares to 5 hectares", value: "Above 2 hectares to 5 hectares", amount: 18000 },
    { label: "Above 5 hectares to 25 hectares", value: "Above 25 hectares to 50 hectares", amount: 90000 },
    { label: "Above 25 hectares to 50 hectares", value: "Above 25 hectares to 50 hectares", amount: 180000 }
  ],
  nonMining: [
    { label: "Upto Rs.5 Crores", value: "Upto Rs.5 Crores", amount: 100000 },
    { label: "Above Rs.5 Crores to Rs.25 Crores", value: "Above Rs.5 Crores to Rs.25 Crores", amount: 180000 },
    { label: "Above Rs.25 Crores to Rs.100 Crores", value: "Above Rs.25 Crores to Rs.100 Crores", amount: 270000 },
    { label: "Above Rs.100 Crores", value: "Above Rs.100 Crores", amount: 450000 }
  ]
};

// Dummy admin credentials for demonstration
const dummyAdmins = [
  { username: 'admin1@example.com', password: 'admin123' },
  { username: 'admin2@example.com', password: 'admin456' },
  { username: 'admin3@example.com', password: 'admin789' }
];

const PaymentForm = () => {
  const [formData, setFormData] = useState({
    proponentName: '',
    projectType: '',
    subCategory: '',
    mobileNumber: '',
    email: '',
    amount: ''
  });

  const [activeTab, setActiveTab] = useState('fees');
  const [receiptInputs, setReceiptInputs] = useState({
    registrationNo: '', // This will map to razorpay_order_id on backend search
    mobileNumber: ''
  });
  const [fetchedReceipts, setFetchedReceipts] = useState([]); // State to store fetched receipts

  // State for admin login form
  const [loginInputs, setLoginInputs] = useState({
    username: '',
    password: ''
  });

  const navigate = useNavigate();
  const formRef = useRef(null);
  const currentOrderId = useRef(null); // To store order_id for failed payments

  useEffect(() => {
    // Load Razorpay script only once
    const loadRazorpay = () => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => {
        console.log('Razorpay script loaded successfully.');
      };
      script.onerror = () => {
        console.error('Failed to load Razorpay script.');
      };
      document.body.appendChild(script);
    };
    loadRazorpay();
  }, []);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    const newForm = { ...formData, [name]: value };

    if (name === "projectType" || name === "subCategory") {
      const match = subCategoryOptions[newForm.projectType]?.find(opt => opt.value === newForm.subCategory);
      newForm.amount = match?.amount || '';
    }

    setFormData(newForm);
  };

  const isFormValid = () => {
    const { proponentName, projectType, subCategory, mobileNumber, email, amount } = formData;
    // Basic validation: ensure all fields have a value
    return proponentName && projectType && subCategory && mobileNumber && email && amount;
  };

  const handleSubmit = (type) => {
    if (!isFormValid()) {
      alert('Please fill all required fields.');
      return;
    }
    console.log(`${type} submitted:`, formData);
    // For 'Cash Collection' or 'Cancel', you would typically handle this logic here,
    // e.g., send data to a different endpoint or clear the form.
  };

  const handlePayOnline = async () => {
    if (!isFormValid()) {
      alert('Please fill all required fields before proceeding with payment.');
      return;
    }

    try {
      // 1. Create Razorpay order on your backend
      console.log('Attempting to create Razorpay order with:', formData.amount, formData.proponentName);
      const apiURL = process.env.REACT_APP_API_URL || 'YOUR_FIREBASE_FUNCTION_URL';
      console.log('API URL being used:', apiURL);

      const orderResponse = await axios.post(`${apiURL}/api/create-razorpay-order`, {
        amount: formData.amount,
        customer_name: formData.proponentName,
        customer_phone: formData.mobileNumber,
        customer_email: formData.email,
        project_type: formData.projectType, // Pass additional data for notes
        sub_category: formData.subCategory   // Pass additional data for notes
      });

      console.log('Backend Order Response:', orderResponse.data);

      const { order_id, key_id } = orderResponse.data;
      currentOrderId.current = order_id; // Store the order ID for potential failure handling

      // Crucial check: Ensure key_id is received
      if (!key_id) {
        console.error('Error: Razorpay key_id is missing from backend response.');
        alert('Payment initiation failed: Razorpay Key is missing. Please contact support.');
        navigate('/thank-you', { state: { status: 'failed' } });
        return;
      }

      // Ensure Razorpay script is loaded
      if (!window.Razorpay) {
        alert('Razorpay SDK not loaded. Please try again or refresh the page.');
        return;
      }

      // 2. Initialize Razorpay Checkout
      const options = {
        key: key_id,
        order_id: order_id,
        amount: formData.amount * 100, // Amount in paise
        currency: "INR",
        name: "Hithlaksh Software Solutions", // Your company name
        description: "Payment for services",
        handler: async (response) => {
          try {
            // 3. Verify payment on your backend and save details to Firestore
            console.log('Razorpay payment successful, verifying with backend...');
            const verifyResponse = await axios.post(
              `${apiURL}/api/verify-payment`,
              {
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
                formData: formData // Pass the full form data to the backend
              }
            );

            console.log('Backend Verification Response:', verifyResponse.data);

            // 4. Redirect based on backend response
            if (verifyResponse.data.redirectUrl) {
              window.location.href = verifyResponse.data.redirectUrl;
            } else {
              // Fallback if backend doesn't provide redirectUrl
              navigate('/thank-you', {
                state: {
                  status: 'success',
                  paymentId: response.razorpay_payment_id,
                  receiptUrl: verifyResponse.data.receiptUrl // Pass receipt URL
                }
              });
            }
          } catch (error) {
            console.error('Payment verification failed on frontend:', error.response?.data || error.message);
            // Navigate to thank-you page with failed status
            alert(`Payment verification failed: ${error.response?.data?.error || error.message}`);
            navigate('/thank-you', { state: { status: 'failed' } });
          }
        },
        prefill: {
          name: formData.proponentName,
          email: formData.email,
          contact: formData.mobileNumber
        },
        theme: {
          color: "#3399cc"
        }
      };

      const rzp = new window.Razorpay(options);
      rzp.on('payment.failed', async function (response) {
        console.error('Razorpay payment failed:', response.error);

        // Call backend to update payment status to 'failed' in Firestore
        if (currentOrderId.current) {
          try {
            await axios.post(`${apiURL}/api/update-payment-status`, {
              order_id: currentOrderId.current,
              error_details: response.error.description || 'User cancelled payment'
            });
            console.log('Payment status updated to failed in Firestore.');
          } catch (firestoreError) {
            console.error('Failed to update payment status in Firestore on Razorpay failure:', firestoreError);
          }
        }

        alert(`Payment Failed: ${response.error.description || 'Unknown error'}. Error code: ${response.error.code}`);
        navigate('/thank-you', { state: { status: 'failed' } });
      });
      rzp.open();

    } catch (error) {
      console.error('Error creating Razorpay order:', error.response?.data || error.message);
      // If order creation itself failed (e.g., due to backend auth error), then currentOrderId.current might not be set.
      // No Firestore update here as no Razorpay order_id was generated.
      alert(`Payment initiation failed: ${error.response?.data?.error || error.message}`);
      navigate('/thank-you', { state: { status: 'failed' } });
    }
  };

  const handleReceiptChange = (e) => {
    setReceiptInputs({ ...receiptInputs, [e.target.name]: e.target.value });
  };

  const handleViewReceipts = async () => {
    const searchKey = receiptInputs.registrationNo || receiptInputs.mobileNumber;
    if (!searchKey) {
      alert('Please enter either Registration Number or Mobile Number to search for receipts.');
      return;
    }

    try {
      // Make a GET request to the new backend endpoint
      const apiURL = process.env.REACT_APP_API_URL || 'YOUR_FIREBASE_FUNCTION_URL';
      const response = await axios.get(
        `${apiURL}/api/payments/${searchKey}`
      );

      if (response.data.payments.length === 0) {
        alert('No payments found for the given criteria.');
        setFetchedReceipts([]); // Clear previous results
      } else {
        // Ensure timestamps are converted for display
        const paymentsWithFormattedDates = response.data.payments.map(payment => ({
          ...payment,
          timestamp: payment.timestamp ? new Date(payment.timestamp).toLocaleString() : 'N/A',
          updatedAt: payment.updatedAt ? new Date(payment.updatedAt).toLocaleString() : 'N/A'
        }));
        setFetchedReceipts(paymentsWithFormattedDates); // Store fetched payments in state
        console.log('Fetched payments:', response.data.payments);
      }
    } catch (error) {
      console.error('Failed to fetch payments:', error.response?.data || error.message);
      alert('Failed to fetch payments. Please check the search criteria and try again.');
      setFetchedReceipts([]); // Clear previous results on error
    }
  };

  // Handler for admin login form changes
  const handleLoginChange = (e) => {
    setLoginInputs({ ...loginInputs, [e.target.name]: e.target.value });
  };

  // Handler for admin login submission
  const handleLoginSubmit = () => {
    const { username, password } = loginInputs;

    const isValid = dummyAdmins.some(
      (admin) => admin.username === username && admin.password === password
    );

    if (isValid) {
      alert('Login successful');
      navigate('/admin/dashboard'); // ✅ Match the route defined in App.js
    } else {
      alert('Invalid username or password');
    }
  };

  return (
    <Box className="payment-container">
      <div className="tab-buttons">
        <button
          className={activeTab === 'fees' ? 'active-tab' : ''}
          onClick={() => setActiveTab('fees')}
        >
          FEES PAYMENT
        </button>
        <button
          className={activeTab === 'receipts' ? 'active-tab' : ''}
          onClick={() => setActiveTab('receipts')}
        >
          PAYMENT RECEIPTS
        </button>
        <button
          className={activeTab === 'admin' ? 'active-tab' : ''}
          onClick={() => setActiveTab('admin')}
        >
          ADMIN LOGIN
        </button>
      </div>

      {activeTab === 'fees' ? (
        <>
          <Typography variant="h6" mb={2}>Payment Form</Typography>
          <div className="form-grid">
            <TextField fullWidth label="Proponent Name *" name="proponentName" value={formData.proponentName} onChange={handleFormChange} />
            <TextField select fullWidth label="Project Type *" name="projectType" value={formData.projectType} onChange={handleFormChange}>
              <MenuItem value="" disabled>Select option</MenuItem>
              <MenuItem value="mining">Mining</MenuItem>
              <MenuItem value="nonMining">Non Mining</MenuItem>
            </TextField>
            <TextField select fullWidth label="Sub Category *" name="subCategory" value={formData.subCategory} onChange={handleFormChange} disabled={!formData.projectType}>
              <MenuItem value="" disabled>Select option</MenuItem>
              {(subCategoryOptions[formData.projectType] || []).map((option) => (
                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
              ))}
            </TextField>
            <TextField fullWidth label="Mobile Number *" name="mobileNumber" value={formData.mobileNumber} onChange={handleFormChange} />
            <TextField fullWidth label="Email *" name="email" value={formData.email} onChange={handleFormChange} />
            <TextField fullWidth label="Amount *" name="amount" type="number" value={formData.amount} InputProps={{ readOnly: true }} />
          </div>

          <Box mt={3} className="action-buttons">
            <Button variant="outlined" className="form-button cancel-btn" onClick={() => handleSubmit('Cancel')}>Cancel</Button>
            <Button variant="contained" className="form-button cash-btn" onClick={() => handleSubmit('Cash')}>Cash Collection</Button>
            <Button variant="contained" className="form-button pay-btn" onClick={handlePayOnline}>Pay Online</Button>
          </Box>
        </>
      ) : activeTab === 'receipts' ? (
        <Box className="receipt-wrapper">
          <Typography variant="h6" mb={2}>Receipt Lookup</Typography>
          <p>Enter Registration Number OR Mobile Number to view previous receipts</p>
          <div className="receipt-form">
            <TextField
              label="Registration No (e.g., Razorpay Order ID)"
              name="registrationNo"
              value={receiptInputs.registrationNo}
              onChange={handleReceiptChange}
              fullWidth
              helperText="This field is currently mapped to Razorpay Order ID for lookup."
            />
            <TextField
              label="Mobile Number"
              name="mobileNumber"
              value={receiptInputs.mobileNumber}
              onChange={handleReceiptChange}
              fullWidth
            />
            <Button
              variant="contained"
              className="view-btn"
              onClick={handleViewReceipts}
            >
              VIEW RECEIPTS
            </Button>
          </div>

          {fetchedReceipts.length > 0 && (
            <Box mt={4}>
              <Typography variant="h6">Found Receipts:</Typography>
              <Paper elevation={3} style={{ maxHeight: 300, overflow: 'auto', marginTop: '10px' }}>
                <List>
                  {fetchedReceipts.map((receipt, index) => (
                    <React.Fragment key={receipt.id}>
                      <ListItem alignItems="flex-start">
                        <ListItemText
                          primary={`Payment ID: ${receipt.razorpay_payment_id || 'N/A'}`}
                          secondary={
                            <>
                              <Typography component="span" variant="body2" color="text.primary">
                                Customer: {receipt.customer_name || 'N/A'} - Mobile: {receipt.customer_phone || 'N/A'}
                              </Typography>
                              <br />
                              Amount: ₹{receipt.amount} ({receipt.project_type} - {receipt.sub_category})
                              <br />
                              Order ID: {receipt.razorpay_order_id}
                              <br />
                              Status: **{receipt.status.toUpperCase()}** {receipt.razorpay_error && `(${receipt.razorpay_error})`}
                              <br />
                              {/* Display already formatted timestamps */}
                              {receipt.timestamp && `Initiated: ${receipt.timestamp}`}
                              {receipt.updatedAt && ` | Last Updated: ${receipt.updatedAt}`}
                              <br />
                              {receipt.pdf_receipt_url && receipt.status === 'completed' && (
                                <a href={receipt.pdf_receipt_url} target="_blank" rel="noopener noreferrer">View Receipt PDF</a>
                              )}
                            </>
                          }
                        />
                      </ListItem>
                      {index < fetchedReceipts.length - 1 && <Divider component="li" />}
                    </React.Fragment>
                  ))}
                </List>
              </Paper>
            </Box>
          )}
        </Box>
      ) : ( // This is the 'admin' tab
        <Box className="receipt-wrapper">
          <Typography variant="h6" mb={2}>Admin Login</Typography>
          <div className="admin-login-form">
            <div className="admin-field-wrapper">
              <TextField
                label="Username"
                name="username"
                value={loginInputs.username}
                onChange={handleLoginChange}
                fullWidth
              />
            </div>
            <div className="admin-field-wrapper">
              <TextField
                label="Password"
                type="password"
                name="password"
                value={loginInputs.password}
                onChange={handleLoginChange}
                fullWidth
              />
            </div>
            <div className="login-row">
              <Link href="#" underline="hover" className="forgot-link">Forgot Password?</Link>
              <Button variant="contained" onClick={handleLoginSubmit}>LOGIN</Button>
            </div>
          </div>
        </Box>
      )}
    </Box>
  );
};

export default PaymentForm;